import { IBadgeStyle } from '@faire/web-api--source/indigofair/badges/IBadgeStyle';

export namespace IBadge {
  export enum BadgeType {
    BADGE_TYPE_UNKNOWN = 'BADGE_TYPE_UNKNOWN',
    NEW_BADGE = 'NEW_BADGE',
    HIGH_SELL_THROUGH = 'HIGH_SELL_THROUGH',
    BESTSELLER = 'BESTSELLER',
    /**
     * @deprecated
     */
    TOP_SHOP = 'TOP_SHOP',
    SHOWROOM = 'SHOWROOM',
    PREVIOUSLY_ORDERED = 'PREVIOUSLY_ORDERED',
    PREORDER = 'PREORDER',
    BRAND_BESTSELLER = 'BRAND_BESTSELLER',
    FAIRE_BESTSELLER = 'FAIRE_BESTSELLER',
    /**
     * @deprecated
     */
    HIGH_SELL_THROUGH_V4 = 'HIGH_SELL_THROUGH_V4',
    /**
     * @deprecated
     */
    HIGH_SELL_THROUGH_V5 = 'HIGH_SELL_THROUGH_V5',
    HIGH_SELL_THROUGH_V6 = 'HIGH_SELL_THROUGH_V6',
    TRENDING = 'TRENDING',
    /**
     * Backend only: should not be exposed to clients, should be converted to TRENDING if returned to clients.
     */
    INTERNAL_TRENDING_NAM = 'INTERNAL_TRENDING_NAM',
    /**
     * Backend only: should not be exposed to clients, should be converted to TRENDING if returned to clients.
     */
    INTERNAL_TRENDING_EUROPE = 'INTERNAL_TRENDING_EUROPE',
    VOLUME_PRICING = 'VOLUME_PRICING',
  }

  /**
   * Redacted copy of IBadge (i.e. without redacted fields).
   */
  export type Redacted = Omit<IBadge, 'xp_settings'>;

  /**
   * Return an instance of IBadge with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IBadge>): IBadge =>
    ({
      xp_settings: [],
      ...(partial ?? {}),
    }) as IBadge;
}

export interface IBadge {
  /**
   * Priority of badge relative to others in the same slot
   */
  priority: number | undefined;
  /**
   * Type of badge, what information it displays
   */
  type: keyof typeof IBadge.BadgeType | undefined;
  /**
   * Whether to show badge to user. All badges have impressions recorded, but ones where this is false will be filtered out before sent to FE
   */
  display_to_user: boolean | undefined;
  /**
   * Filled in style for badge
   */
  style: IBadgeStyle | undefined;
  /**
   * Internal BE only field for recording if a badge is introduced as an XP and should trigger setting assignment
   * @protobufOption (indigofair.data.redacted) = true
   */
  xp_settings: Array<string>; // redacted
}
